import { createApi } from '@reduxjs/toolkit/query/react';
import { authBaseQuery } from '../utils/authBaseQuery';

const baseUrl =
  process.env.NEXT_PUBLIC_USE_SECURITY === 'true'
    ? process.env.NEXT_PUBLIC_API_SECURITY
    : process.env.NEXT_PUBLIC_API_CHECKOUT;

export const surveysApi = createApi({
  reducerPath: 'surveysApi',
  baseQuery: authBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const { security } = getState();
      if (security?.recaptchaToken) {
        headers.set('x-recaptcha-token', security.recaptchaToken);
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 0,
  tagTypes: ['Surveys'],
  endpoints: (build) => ({
    getBookingSurvey: build.query({
      query: ({ event, ticketNumber }) =>
        `questions-forms-core/api/v1/questions/events/${event}${
          ticketNumber ? `?ticket_number=${ticketNumber}` : ''
        }`,
    }),
    getTicketSurveyAnswers: build.query({
      query: ({ ticketNumber }) =>
        `questions-forms-core/api/v1/tickets/${ticketNumber}/answers`,
      providesTags: (result, error, { ticket }) => [
        { type: 'Surveys', id: `ticket-${ticket}` },
      ],
    }),
    saveBookingSurvey: build.mutation({
      query: ({ event, booking, answers }) => ({
        url: `questions-forms-core/api/v1/events/${event}/answers/booking/${booking}`,
        method: 'POST',
        body: answers,
      }),
    }),
    getSavedAnswers: build.query({
      query: ({ event, booking }) =>
        `questions-forms-core/api/v1/events/${event}/answers/booking/${booking}`,
    }),
    customTickets: build.mutation({
      query: (body) => ({
        url: 'bookings-core/api/v1/bookings/custom-tickets',
        method: 'PUT',
        body,
      }),
    }),
    saveTicketSurveyAnswers: build.mutation({
      query: ({ ticketId, answers }) => ({
        url: `questions-forms-core/api/v1/tickets/${ticketId}/answers`,
        headers: { 'Application-Name': 'wallet' },
        method: 'PATCH',
        body: answers,
      }),
      invalidatesTags: (result, error, { ticket }) => [
        { type: 'Surveys', id: `ticket-${ticket}` },
      ],
    }),
  }),
});

export const {
  useGetBookingSurveyQuery,
  useLazyGetBookingSurveyQuery,
  useSaveBookingSurveyMutation,
  useGetSavedAnswersQuery,
  useLazyGetSavedAnswersQuery,
  useCustomTicketsMutation,
  useGetTicketSurveyAnswersQuery,
  useLazyGetTicketSurveyAnswersQuery,
  useSaveTicketSurveyAnswersMutation,
} = surveysApi;

export const {
  getBookingSurvey: { useQueryState: useGetBookingSurveyQueryState },
  getSavedAnswers: { useQueryState: useGetSavedAnswersQueryState },
} = surveysApi.endpoints;
